import { useState, useCallback } from "react";

import { Button } from "reactstrap";
import { PlusIcon } from "@heroicons/react/24/outline";

import { CreateAssignmentModal } from "./CreateAssignmentModal";

interface CreateAssignmentModalButtonProps {
  campaign_id?: string;
  creator_id?: string;
}

export const CreateAssignmentModalButton = ({
  campaign_id,
  creator_id,
}: CreateAssignmentModalButtonProps) => {
  const [isCreateAssignmentModalOpen, setIsCreateAssignmentModalOpen]
    = useState(false);

  const handleOpenCreateAssignmentModal = useCallback(() => {
    setIsCreateAssignmentModalOpen(true);
  }, []);

  const handleCloseCreateAssignmentModal = useCallback(() => {
    setIsCreateAssignmentModalOpen(false);
  }, []);

  return (
    <>
      <Button
        color="dark"
        className="ms-3 d-flex align-items-center"
        onClick={handleOpenCreateAssignmentModal}
      >
        <PlusIcon height={20} width={20} className="me-2" />
        {"Create Assignment"}
      </Button>

      <CreateAssignmentModal
        campaign_id={campaign_id}
        creator_id={creator_id}
        isOpen={isCreateAssignmentModalOpen}
        onClose={handleCloseCreateAssignmentModal}
      />
    </>
  );
};
